import DashboardContainer from '@/containers/interaction/DashboardContainer';

export default [
  {
    path: '/dashboard',
    name: 'Dashboard',
    meta: { requiresAuth: true, action: 'view', subject: 'radio-dashboard' },
    component: DashboardContainer,
  },
];



// WEBPACK FOOTER //
// ./src/router/dashboard.js